<template>
  <!-- Modal -->

  <div>
    <!-- default -->
    <div
      class="modal fade"
      id="msgModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{getMessage.title}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            {{getMessage.message}}
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- centerWithoutButton -->
    <div
      class="modal fade"
      id="centerWithoutButton"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalCenterTitle">{{getMessage.title}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">{{getMessage.message}}</div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>

    <!-- success modal -->
    <div
      class="modal fade"
      id="successModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{getMessage.title}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">{{getMessage.message}}</div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="confirmModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{getMessage.title}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">{{getMessage.message}}</div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              id="confirmModalBtn"
            >Confirm</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "message",
  mounted() {
    // $("#successModal").modal("show")
  },
  computed: {
    ...mapGetters("message", ["getMessage"])
  },

  methods: {
    ...mapActions("message", ["actionSetMessage", "actionResetMessage"]),
    ...mapActions("message", ["actionSetMessage", "actionResetMessage"])
  },

  watch: {
    getMessage: function(val) {
      if (val.message) {
        //default
        if (!val.code) {
          $("#msgModel").modal("show");
        } else if (val.code == 1) {
          $("#centerWithoutButton").modal("show");
        } else if (val.code == 2) {
          console.log("success");
          $("#successModal").modal("show");

          setTimeout(() => {
            $("#successModal").modal("hide");
            this.actionResetMessage();
          }, 1500);
        } else if (val.code == 3) {
          $("#confirmModal").modal("show");
        }
      }
    }
  }
};
</script>